import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import TemplateLayer from "../components/TemplateLayer";


const TemplateList = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Templates" />


        {/* TemplateLayer */}
        <TemplateLayer />

      </MasterLayout>
    </>
  )
};

export default TemplateList;
